/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/close-black-regular': {
    width: 33,
    height: 33,
    viewBox: '0 0 33 33',
    //stroke-width="2.5"
    data: '<path pid="0" d="M2.27 2.27L30.73 30.73M30.731 2.27L2.27 30.73" _stroke="#000"  stroke-linecap="square"/>'
  }
})
